module.exports = __webpack_public_path__ + "img/card.c64cd75c.png";